import axios from "axios";
import https from 'https'
import utils from "../utils/utils"
const xml2js = require('xml2js');

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';// Ojo esto para no validar el certificado luego borrar

var urlPdf = "https://181.39.87.158:7777/api/GuiasWeb/"
var urlRotulos = "https://181.39.87.158:8021/api/ImprimeRotulos/"
var urlStickers = "https://181.39.87.158:8021/api/ImprimeSticker/"
var urlTracking = "https://servientrega-ecuadorsf.appsiscore.com/app/ws/server_trazabilidad.php?wsdl"
var config = {
  responseType: 'json',
  httpsAgent: agent
}
let usuario = 'in.courier';
let clave = '123456';
const agent = new https.Agent({
  rejectUnauthorized: false
});
var apiServiEntrega = {
  imprimirGuia: function(guia){
    config.responseType = 'arraybuffer'
    let compleUrl = "['" + guia + "','" + usuario + "','" + clave + "','1']"
    axios.get(urlPdf + compleUrl,config).then((result) => {
      utils.forceFileDownload(result.archivoEncriptado,".pdf",true,"Guia_ServiEntrega_" + guia,"application/pdf")
    }).catch((err) => {
      console.log(err)
    })
  },
  generarRotulos: function(guia){
    config.responseType = 'arraybuffer'
    let compleUrl = "['" + guia + "','" + usuario + "','" + clave + "']"
    axios.get(urlRotulos + compleUrl,config).then((result) => {
      utils.forceFileDownload(result.data,".pdf",true,"Rotulos_ServiEntrega_" + guia,"application/pdf")
    })
  },
  generarStickers: function(guia){
    config.responseType = 'arraybuffer'
    let compleUrl = "['" + guia + "','" + usuario + "','" + clave + "']"
    axios.get(urlStickers + compleUrl,config).then((result) => {
      utils.forceFileDownload(result.data,".pdf",true,"Sticker_ServiEntrega_" + guia,"application/pdf")
    })
  },
  getTracking:async function(guia){
    let datosTracking = []
    let xmls='<soapenv:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"\
    xmlns:xsd="http://www.w3.org/2001/XMLSchema"\
    xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ws="https://servientregaecuador.appsiscore.com/app/ws/">\
    <soapenv:Header/>\
    <soapenv:Body>\
    <ws:ConsultarGuiaImagen soapenv:encodingStyle="http://schemas.xmlsoap.org/soap/encoding/">\
    <guia xsi:type="xsd:string">' + guia + '</guia>\
    </ws:ConsultarGuiaImagen>\
    </soapenv:Body>\
    </soapenv:Envelope>'
    await axios.post(urlTracking,xmls,{
      headers:{
        'Content-Type' : 'text/xml'
      }
    }).then((result) => {
      return this.parseSOAPResponse(result.data);
    }).then((jsonResult) => {
      return this.parseXMLStringToJSON(jsonResult)
    }).then((endResult) => {
      datosTracking = endResult
    }).catch((err) => {
      console.log(err)
    })
    return datosTracking
  },
  parseSOAPResponse: function(response) {
    return new Promise((resolve, reject) => {
      const parser = new xml2js.Parser({
        explicitArray: false,
        valueProcessors: [
          xml2js.processors.parseNumbers,
          xml2js.processors.parseBooleans
        ]
      });
      parser.parseString(response, (error, result) => {
        if (error) {
          reject(error);
        } else {
          const body = result['SOAP-ENV:Envelope']['SOAP-ENV:Body'];
          const resultData = body['ns1:ConsultarGuiaImagenResponse']['Result']['_']
          resolve(resultData);
        }
      });
    });
  },
  parseXMLStringToJSON: function(xmlString) {
    return new Promise((resolve, reject) => {
       const parser = new xml2js.Parser({
        explicitArray: false,
        valueProcessors: [
          xml2js.processors.parseNumbers,
          xml2js.processors.parseBooleans
        ]
      });
      parser.parseString(xmlString,  (error, result) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      });
    });
  }

}

export default apiServiEntrega
